import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import md5 from "md5";
import Top from "../Top";
import QuickActionsSidebar from "../DistributorDashboard/QuickActionsSidebar";
import { getDistributorActions } from "../../../config/actions";
import "../../css/QuickActions.css";
import "./APIIntegration.css";

const APIIntegration = () => {
  const navigate = useNavigate();
  const userType = localStorage.getItem("user_type");
  const uid = localStorage.getItem("uid");
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [showDistributorId, setShowDistributorId] = useState(false);

  // if (userType !== "6") {
  //   navigate("/");
  //   return null;
  // }

  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code);
    alert("Code copied to clipboard!");
  };

  const distributorActions = getDistributorActions(localStorage.getItem("uid"));

  return (
    <div className="api-integration-container">
      <div className="api-dashboard">
        {/* QuickActionsSidebar */}
        <QuickActionsSidebar actions={distributorActions} expandedMenu={expandedMenu} setExpandedMenu={setExpandedMenu} />

        {/* Main Content */}
        <div className="api-content">
          <div className="api-header">
            <h1>API Integration Guide</h1>
            <p>Instructions for integrating the BetterPhysiology distributor management system with your shopping cart</p>
          </div>

          {/* Overview Section */}
          <div className="api-section">
            <h2 className="section-title">
              <i className="fas fa-info-circle"></i> Overview
            </h2>
            <p className="section-description">
              The Order API allows you to seamlessly integrate CapnoGO™
              ordering functionality into your website. Customers can
              browse, configure, and submit orders without leaving your platform.
            </p>
          </div>

          {/* Getting Started */}
          <div className="api-section">
            <h2 className="section-title">
              <i className="fas fa-rocket"></i> Getting Started
            </h2>
            <p className="section-description">
              To get started with the API, you'll need:
            </p>
            <ul className="api-list">
              <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                Your API Key:
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#f5f5f5', padding: '6px 12px', borderRadius: '4px', fontFamily: 'monospace', fontWeight: '600' }}>
                  <span>{showDistributorId ? md5(uid) : md5(uid).replace(/./g, '•')}</span>
                  <i
                    className={showDistributorId ? "fa fa-eye-slash" : "fa fa-eye"}
                    onClick={() => setShowDistributorId(!showDistributorId)}
                    style={{ cursor: 'pointer', color: 'rgb(77, 0, 77)' }}
                  ></i>
                </div>
              </li>
              <li>HTTPS endpoint on your website</li>
              <li>Basic understanding of REST APIs</li>
            </ul>
          </div>

          {/* Get All Distributor Sites API */}
          <div className="api-endpoint-section">
            <div className="api-section">
              <h2 className="section-title">
                <i className="fas fa-plug"></i> Get All Distributor Sites
              </h2>
              <p className="section-description">
                Retrieves a list of all sites associated with the distributor.
              </p>

              {/* Endpoint */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Endpoint</h4>
                <div className="api-item">
                  <div className="api-method get">GET</div>
                  <code className="api-endpoint">
                    https://api.capnolearning.com/api/distributor/site
                  </code>
                  <button
                    className="copy-btn"
                    onClick={() =>
                      handleCopyCode(
                        "https://api.capnolearning.com/api/distributor/site"
                      )
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                </div>
              </div>

              {/* Request Example */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Request Headers</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`Authorization: Bearer YOUR_API_KEY
Content-Type: application/json`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`Authorization: Bearer YOUR_API_KEY
Content-Type: application/json`}</pre>
                </div>
              </div>

              {/* Response 200 */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Response 200 - Success</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`{
  "success": true,
  "message": "Sites retrieved successfully",
  "data": [
    {
      "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
      "name": "Main Warehouse",
      "distributor_id": "YOUR_DISTRIBUTOR_ID",
      "created_at": "2026-07-31T15:07:55.000Z"
    },
    {
      "site_id": "f6e5d4c3b2a1f6e5d4c3b2a1f6e5d4c3",
      "name": "East Coast Office",
      "distributor_id": "YOUR_DISTRIBUTOR_ID",
      "created_at": "2026-08-02T09:22:11.000Z"
    }
  ]
}`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`{
  "success": true,
  "message": "Sites retrieved successfully",
  "data": [
    {
      "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
      "name": "Main Warehouse",
      "distributor_id": "YOUR_DISTRIBUTOR_ID",
      "created_at": "2026-07-31T15:07:55.000Z"
    },
    {
      "site_id": "f6e5d4c3b2a1f6e5d4c3b2a1f6e5d4c3",
      "name": "East Coast Office",
      "distributor_id": "YOUR_DISTRIBUTOR_ID",
      "created_at": "2026-08-02T09:22:11.000Z"
    }
  ]
}`}</pre>
                </div>
              </div>
            </div>
          </div>

          {/* Get All Systems API */}
          <div className="api-endpoint-section">
            <div className="api-section">
              <h2 className="section-title">
                <i className="fas fa-plug"></i> Get All CapnoGO™ Systems (configurations of modules)
              </h2>
              <p className="section-description">
                Retrieves a list of all CapnoGO™ systems
              </p>

              {/* Endpoint */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Endpoint</h4>
                <div className="api-item">
                  <div className="api-method get">GET</div>
                  <code className="api-endpoint">
                    https://api.capnolearning.com/api/distributor/systems?site_id=YOUR_SITE_ID
                  </code>
                  <button
                    className="copy-btn"
                    onClick={() =>
                      handleCopyCode(
                        "https://api.capnolearning.com/api/distributor/systems?site_id=YOUR_SITE_ID"
                      )
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                </div>
              </div>

              {/* Query Parameters */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Query Parameters</h4>
                <ul className="api-list">
                  <li><strong>site_id</strong> - ID of the site, from the Get All Distributor Sites API (required). </li>
                </ul>
              </div>

              {/* Request Example */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Request Headers</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`Authorization: Bearer YOUR_API_KEY
Content-Type: application/json`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`Authorization: Bearer YOUR_API_KEY
Content-Type: application/json`}</pre>
                </div>
              </div>

              {/* Response 200 */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Response 200 - Success</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`{
  "status": true,
  "count": 2,
  "inventory": 10,
  "category_id": 22,
  "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
  "currency": "USD",
  "data": [
    {
      "id": 132,
      "name": "CapnoGO™ Advanced System",
      "weight": "1.5",
      "price": 2500,
      "description": "Advanced system with additional features",
      "category": 22,
      "created": "2026-01-10T10:00:00.000Z",
      "updated": "2026-07-31T15:07:55.000Z"
    },
    {
      "id": 133,
      "name": "CapnoGO™ Professional System",
      "weight": "1.5",
      "price": 4000,
      "description": "Professional system with premium features",
      "category": 22,
      "created": "2026-01-10T10:00:00.000Z",
      "updated": "2026-07-31T15:07:55.000Z"
    }
  ]
}`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`{
  "status": true,
  "count": 2,
  "inventory": 10,
  "category_id": 22,
  "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
  "currency": "USD",
  "data": [
    {
      "id": 132,
      "name": "CapnoGO™ Advanced System",
      "weight": "1.5",
      "price": 2500,
      "description": "Advanced system with additional features",
      "category": 22,
      "created": "2026-01-10T10:00:00.000Z",
      "updated": "2026-07-31T15:07:55.000Z"
    },
    {
      "id": 133,
      "name": "CapnoGO™ Professional System",
      "weight": "1.5",
      "price": 4000,
      "description": "Professional system with premium features",
      "category": 22,
      "created": "2026-01-10T10:00:00.000Z",
      "updated": "2026-07-31T15:07:55.000Z"
    }
  ]
}`}</pre>
                </div>
              </div>
            </div>
          </div>

          {/* Get All Modules API */}
          <div className="api-endpoint-section">
            <div className="api-section">
              <h2 className="section-title">
                <i className="fas fa-plug"></i> Get All CapnoGO™ Modules
              </h2>
              <p className="section-description">
                Retrieves a list of all available CapnoGO™ modules
              </p>

              {/* Endpoint */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Endpoint</h4>
                <div className="api-item">
                  <div className="api-method get">GET</div>
                  <code className="api-endpoint">
                    https://api.capnolearning.com/api/distributor/modules?site_id=YOUR_SITE_ID
                  </code>
                  <button
                    className="copy-btn"
                    onClick={() =>
                      handleCopyCode(
                        "https://api.capnolearning.com/api/distributor/modules?site_id=YOUR_SITE_ID"
                      )
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                </div>
              </div>

              {/* Query Parameters */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Query Parameters</h4>
                <ul className="api-list">
                  <li><strong>site_id</strong> - ID of the site, from the Get All Distributor Sites API (required).</li>
                </ul>
              </div>

              {/* Request Example */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Request Headers</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`Authorization: Bearer YOUR_API_KEY
Content-Type: application/json`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`Authorization: Bearer YOUR_API_KEY
Content-Type: application/json`}</pre>
                </div>
              </div>

              {/* Response 200 */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Response 200 - Success</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`{
  "status": true,
  "module_count": 2,
  "inventory": 25,
  "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
  "currency": "USD",
  "price": 250,
  "data": [
    {
      "id": 15,
      "name": "Advanced Features",
      "module_enum": "ADVANCED_FEATURES_MODULE",
      "description": "Extended feature set for advanced users",
      "price": 250,
      "created_at": "2026-01-10T10:00:00.000Z",
      "updated_at": "2026-01-10T10:00:00.000Z"
    },
    {
      "id": 23,
      "name": "HRV (Heart Rate Variability)",
      "module_enum": "HRV_MODULE",
      "description": "Heart Rate Variability analysis module",
      "price": 250,
      "created_at": "2026-01-10T10:00:00.000Z",
      "updated_at": "2026-01-10T10:00:00.000Z"
    }
  ]
}`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`{
  "status": true,
  "module_count": 2,
  "inventory": 25,
  "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
  "currency": "USD",
  "price": 250,
  "data": [
    {
      "id": 15,
      "name": "Advanced Features",
      "module_enum": "ADVANCED_FEATURES_MODULE",
      "description": "Extended feature set for advanced users",
      "price": 250,
      "created_at": "2026-01-10T10:00:00.000Z",
      "updated_at": "2026-01-10T10:00:00.000Z"
    },
    {
      "id": 23,
      "name": "HRV (Heart Rate Variability)",
      "module_enum": "HRV_MODULE",
      "description": "Heart Rate Variability analysis module",
      "price": 250,
      "created_at": "2026-01-10T10:00:00.000Z",
      "updated_at": "2026-01-10T10:00:00.000Z"
    }
  ]
}`}</pre>
                </div>
              </div>
            </div>
          </div>

          {/* Submit Order API */}
          <div className="api-endpoint-section">
            <div className="api-section">
              <h2 className="section-title">
                <i className="fas fa-plug"></i> Submit Order
              </h2>
              <p className="section-description">
                Submit a new order for CapnoGO™ systems and modules
              </p>

              {/* Endpoint */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Endpoint</h4>
                <div className="api-item">
                  <div className="api-method">POST</div>
                  <code className="api-endpoint">
                    https://api.capnolearning.com/api/distributor/submit-order
                  </code>
                  <button
                    className="copy-btn"
                    onClick={() =>
                      handleCopyCode(
                        "https://api.capnolearning.com/api/distributor/submit-order"
                      )
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                </div>
              </div>

              {/* Headers */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Request Headers</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`Authorization: Bearer YOUR_API_KEY
Content-Type: application/json`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`Authorization: Bearer YOUR_API_KEY
Content-Type: application/json`}</pre>
                </div>
              </div>

              {/* Request Body */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Request Body</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`{
  "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
  "customer": {
    "email": "john@example.com"
  },
  "order": {
    "shipping_address": {
      "fname": "John",
      "lname": "Doe",
      "company": "",
      "address_1": "123 Main St",
      "address_2": "",
      "city": "Santa Fe",
      "state": "NM",
      "country": "US",
      "postal": "87501",
      "phone": "5058203376",
      "email": "john@example.com"
    },
    "billing_address": {
      "fname": "Jane",
      "lname": "Doe",
      "company": "Doe Clinic",
      "address_1": "456 Market St",
      "address_2": "Suite 200",
      "city": "Albuquerque",
      "state": "NM",
      "country": "US",
      "postal": "87102",
      "phone": "5055550123",
      "email": "billing@example.com"
    }
  },
  "items": [
    {
      "product_id": 152,
      "qty": 1,
      "price": 1200,
      "modules": [
        { "module_id": 23 },
        { "module_id": 15 }
      ]
    },
    {
      "product_id": 136,
      "qty": 1,
      "price": 20
    }
  ],
  "transaction_id": "YOUR_TRANSACTION_ID",
  "transaction_body": "{}",
  "shipping_method": "Standard",
  "shipping_amount": 25,
  "tax_amount": 15
}`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`{
  "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
  "customer": {
    "email": "john@example.com"
  },
  "order": {
    "shipping_address": {
      "fname": "John",
      "lname": "Doe",
      "company": "",
      "address_1": "123 Main St",
      "address_2": "",
      "city": "Santa Fe",
      "state": "NM",
      "country": "US",
      "postal": "87501",
      "phone": "5058203376",
      "email": "john@example.com"
    },
    "billing_address": {
      "fname": "Jane",
      "lname": "Doe",
      "company": "Doe Clinic",
      "address_1": "456 Market St",
      "address_2": "Suite 200",
      "city": "Albuquerque",
      "state": "NM",
      "country": "US",
      "postal": "87102",
      "phone": "5055550123",
      "email": "billing@example.com"
    }
  },
  "items": [
    {
      "product_id": 152,
      "qty": 1,
      "price": 1200,
      "modules": [
        { "module_id": 23 },
        { "module_id": 15 }
      ]
    },
    {
      "product_id": 136,
      "qty": 1,
      "price": 20
    }
  ],
  "transaction_id": "YOUR_TRANSACTION_ID",
  "transaction_body": "{}",
  "shipping_method": "Standard",
  "shipping_amount": 25,
  "tax_amount": 15
}`}</pre>
                </div>
              </div>

              {/* Fields Documentation */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Field Descriptions</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div>
                    <h5 style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '8px' }}>Customer Object</h5>
                    <ul className="api-list">
                      <li><strong>email</strong> - Customer's email address (required)</li>
                    </ul>
                  </div>
                  <div>
                    <h5 style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '8px' }}>Order Object</h5>
                    <ul className="api-list">
                      <li><strong>shipping_address</strong> - Complete shipping address object (required), see fields below</li>
                      <li><strong>billing_address</strong> - Billing address object, same fields as the shipping address (optional, defaults to the shipping address). If its email differs from the shipping email, the order confirmation is sent to both.</li>
                    </ul>
                  </div>
                  <div>
                    <h5 style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '8px' }}>Shipping / Billing Address Object</h5>
                    <ul className="api-list">
                      <li><strong>fname</strong> - Recipient's first name (required)</li>
                      <li><strong>lname</strong> - Recipient's last name (required)</li>
                      <li><strong>company</strong> - Company name (optional)</li>
                      <li><strong>address_1</strong> - Street address, line 1 (required)</li>
                      <li><strong>address_2</strong> - Street address, line 2 (optional)</li>
                      <li><strong>city</strong> - City (required)</li>
                      <li><strong>state</strong> - State/province code (required)</li>
                      <li><strong>country</strong> - Two-letter country code (required)</li>
                      <li><strong>postal</strong> - Postal/ZIP code (required)</li>
                      <li><strong>phone</strong> - Recipient's phone number (required)</li>
                      <li><strong>email</strong> - Recipient's email address (required)</li>
                    </ul>
                  </div>
                  <div>
                    <h5 style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '8px' }}>Items Array</h5>
                    <ul className="api-list">
                      <li><strong>product_id</strong> - Numeric ID of the product/system (required)</li>
                      <li><strong>qty</strong> - Quantity of this product (required)</li>
                      <li><strong>price</strong> - Unit price of the product, in the selected site's currency (required)</li>
                      <li><strong>modules</strong> - Array of module objects included with this product (optional)</li>
                    </ul>
                  </div>
                  <div>
                    <h5 style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '8px' }}>Module Object (within items)</h5>
                    <ul className="api-list">
                      <li><strong>module_id</strong> - Numeric ID of the module (required)</li>
                    </ul>
                  </div>
                  <div>
                    <h5 style={{ fontSize: '13px', fontWeight: '700', color: '#333', marginBottom: '8px' }}>Top-Level Fields</h5>
                    <ul className="api-list">
                      <li><strong>site_id</strong> - ID of the site the order is placed for, from the Get All Distributor Sites API (required). The order uses this site's module price and currency.</li>
                      <li><strong>transaction_id</strong> - Your own unique identifier for this transaction/payment (required)</li>
                      <li><strong>transaction_body</strong> - JSON string with any additional transaction metadata you want stored, e.g. payment gateway response (optional, defaults to "{}")</li>
                      <li><strong>shipping_method</strong> - Shipping method label, e.g. "Standard" (required)</li>
                      <li><strong>shipping_amount</strong> - Shipping charge for the order, 0 or more (optional, defaults to 0)</li>
                      <li><strong>tax_amount</strong> - Tax charged on the order, 0 or more (optional, defaults to 0)</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Response 200 */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Response 200 - Success</h4>
                <div className="code-block">
                  <button
                    className="copy-btn-large"
                    onClick={() =>
                      handleCopyCode(`{
  "success": true,
  "message": "Order submitted successfully",
  "order_id": 1439,
  "data": {
    "order_id": 1439,
    "distributor_id": "YOUR_DISTRIBUTOR_ID",
    "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
    "status": "CONFIRM",
    "currency": "USD",
    "subtotal": 1220,
    "shipping_amount": 25,
    "tax_amount": 15,
    "total_amount": 1260,
    "created_at": "2026-07-31T15:07:55.000Z",
    "device_registrations": [
      {
        "product_id": 152,
        "unique_order": "ZDW695"
      }
    ]
  }
}`)
                    }
                  >
                    <i className="fas fa-copy"></i> Copy
                  </button>
                  <pre>{`{
  "success": true,
  "message": "Order submitted successfully",
  "order_id": 1439,
  "data": {
    "order_id": 1439,
    "distributor_id": "YOUR_DISTRIBUTOR_ID",
    "site_id": "a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4",
    "status": "CONFIRM",
    "currency": "USD",
    "subtotal": 1220,
    "shipping_amount": 25,
    "tax_amount": 15,
    "total_amount": 1260,
    "created_at": "2026-07-31T15:07:55.000Z",
    "device_registrations": [
      {
        "product_id": 152,
        "unique_order": "ZDW695"
      }
    ]
  }
}`}</pre>
                </div>
              </div>

              {/* Response 400 */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Response 400 - Bad Request</h4>
                <div className="code-block">
                  <pre>{`{
  "success": false,
  "message": "Missing required fields",
  "errors": [
    "site_id is required",
    "customer.email is required",
    "order.shipping_address is required"
  ]
}`}</pre>
                </div>
              </div>

              {/* Response 401 */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Response 401 - Unauthorized</h4>
                <div className="code-block">
                  <pre>{`{
  "success": false,
  "message": "Invalid API key or distributor ID"
}`}</pre>
                </div>
              </div>
            </div>
          </div>

          {/* Implementation Example */}
          <div className="api-section">
            <h2 className="section-title">
              <i className="fas fa-laptop-code"></i> Implementation Example
            </h2>
            <p className="section-description">
              Example using JavaScript/Fetch API:
            </p>
            <div className="code-block">
              <button
                className="copy-btn-large"
                onClick={() =>
                  handleCopyCode(`async function submitOrder(orderData) {
  try {
    const response = await fetch(
      'https://api.capnolearning.com/api/distributor/submit-order',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer YOUR_API_KEY',
        },
        body: JSON.stringify(orderData)
      }
    );

    const result = await response.json();

    if (result.success) {
      console.log('Order submitted:', result.data);
      return result.data;
    } else {
      console.error('Error:', result.message);
      throw new Error(result.message);
    }
  } catch (error) {
    console.error('Request failed:', error);
    throw error;
  }
}`)
                }
              >
                <i className="fas fa-copy"></i> Copy Code
              </button>
              <pre>{`async function submitOrder(orderData) {
  try {
    const response = await fetch(
      'https://api.capnolearning.com/api/distributor/submit-order',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer YOUR_API_KEY',
        },
        body: JSON.stringify(orderData)
      }
    );

    const result = await response.json();

    if (result.success) {
      console.log('Order submitted:', result.data);
      return result.data;
    } else {
      console.error('Error:', result.message);
      throw new Error(result.message);
    }
  } catch (error) {
    console.error('Request failed:', error);
    throw error;
  }
}`}</pre>
            </div>
          </div>

          {/* Support Section */}
          <div className="api-section api-support">
            <h2 className="section-title">
              <i className="fas fa-headset"></i> Need Help?
            </h2>
            <p>
              For technical support or API issues, please contact our support team at{" "}
              <a href="mailto:api-support@capnolearning.com">api-support@capnolearning.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APIIntegration;
